import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import * as React from 'react';
import {
  GREEN_COLOR,
  ORANGE_COLOR,
  RED_COLOR,
} from '../../../../../constants/ColorsConst';

const ColumnChartNotasEvaluativas = ({ estudiantes, actividadesArray }) => {
  const [categories, setCategories] = React.useState([]);
  const [data, setData] = React.useState(null);

  const arrayData = ['REPROBADOS', 'REGULARES', 'EXIMIDOS'];
  React.useEffect(() => {
    let list = [];
    actividadesArray.forEach((a) => {
      list.push(a.instrumento.nombre);
    });
    setCategories(list);

    let d = [];
    arrayData.forEach((el, index) => {
      let x = [];
      actividadesArray.forEach((a) => {
        x.push({
          id: a.id,
          count: 0,
        });
      });
      d.push({
        id: index,
        name: el,
        data: x,
      });
    });

    actividadesArray.forEach((act) => {
      estudiantes.forEach((est) => {
        est.notasEvaluativas.forEach((nota) => {
          if (act.id === nota.ptevaInstrumento.id) {
            const n = parseInt(nota.nota ?? '0');
            let r = 0;

            if (n <= 15 && n > 9) r = 1;
            if (n > 15) r = 2;

            const dx = d.find((el) => el.id === r);

            let dCount = dx.data.find((el) => el.id === act.id);

            dCount['count'] = dCount.count + 1;

            const dxData = dx.data.filter((el) => el.id !== act.id);
            dxData.push(dCount);
            dx['data'] = dxData;

            const dDatas = d.filter((el) => el.id !== r);
            dDatas.push(dx);
          }
        });
      });
    });

    const res = [];
    d.forEach((el) => {
      let dtr = [];
      actividadesArray.forEach((ac) => {
        const find = el.data.find((it) => ac.id === it.id);
        dtr.push(find.count);
      });
      res.push({
        id: el.id,
        data: dtr,
      });
    });

    setData(res);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estudiantes]);

  return (
    data && (
      <HighchartsReact
        highcharts={Highcharts}
        options={{
          chart: {
            type: 'column',
          },
          title: {
            text: `Total por actividades de ${estudiantes.length} estudiantes`,
            align: 'center',
          },
          xAxis: {
            categories,
          },
          yAxis: {
            min: 0,
            title: {
              text: 'Contador total',
            },
            stackLabels: {
              enabled: false,
            },
          },
          plotOptions: {
            column: {
              stacking: 'normal',
              dataLabels: {
                enabled: true,
              },
            },
          },
          legend: {
            align: 'center',
            x: 50,
            verticalAlign: 'top',
            y: 30,
            floating: true,
            backgroundColor:
              Highcharts.defaultOptions.legend.backgroundColor || 'white',
            borderColor: '#fff',
            borderWidth: 1,
            shadow: false,
          },
          tooltip: {
            headerFormat: '<b>{point.x}</b><br/>',
            pointFormat:
              '{series.name}: {point.y}<br/>Total: {point.stackTotal}',
          },
          series: [
            {
              name: 'REPROBADOS',
              data: data.find((el) => el.id === 0).data,
              color: RED_COLOR,
            },
            {
              name: 'REGULAR',
              data: data.find((el) => el.id === 1).data,
              color: ORANGE_COLOR,
            },
            {
              name: 'EXIMIDOS',
              data: data.find((el) => el.id === 2).data,
              color: GREEN_COLOR,
            },
          ],
        }}
      />
    )
  );
};

export default ColumnChartNotasEvaluativas;
